import { Loader } from './Loader';

type CardProps = {
  children: React.ReactNode;
  loading?: boolean;
  loadingMessage?: string;
  title: React.ReactNode;
  button?: React.ReactNode;
};

export function Card({
  children,
  loading = false,
  loadingMessage = 'Loading data, please wait...',
  title,
  button,
}: CardProps) {
  return (
    <div className="bg-background border-border rounded-card relative flex w-full flex-col items-start border px-6 py-4">
      <div className="mb-6 flex w-full flex-col justify-between gap-6 sm:flex-row">
        <h2
          className="text-shadow text-xl"
          data-testid="cd-consent-settings-heading"
        >
          {title}
        </h2>
        {button || <></>}
      </div>
      {loading ? (
        <div className="flex w-full items-center px-12 py-6">
          <Loader />
          <p>{loadingMessage}</p>
        </div>
      ) : (
        <div className="w-full space-y-6">{children}</div>
      )}
    </div>
  );
}
